<template>
    <div class="pulse_loader">
        <div class="loader_anim" v-if="loading && !quote && !backgroundWhite">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
         <div class="loader_anim" v-else-if="loading && backgroundWhite">
            <div>
                <img class="img-loader-gif-white" src="/img/loading-bg-white.gif" alt="">
            </div>           
        </div>
        <!-- <div class="p-fixed" v-else-if="loading && quote"> -->
        <div v-else-if="loading && quote">
            <div v-if="logo">
                <img src="/img/loading-bg-white.gif" alt="">
            </div> 
            <div v-else>
                <img src="/img/loading.gif" alt="">
            </div>             
        </div>
        <!--<div v-if="quote && loading" class="loader_text mt-0">
            {{msg[i].quote}}
        </div>-->
       <!-- <div v-if="author && true" class="author">
            <span><img :src="/img/+ msg[i].img" alt=""></span>
            <div>
                <h4>{{msg[i].author}}</h4>
                <h6>{{msg[i].profession}}</h6>
            </div>
        </div>-->
    </div>
</template>

<script>

export default {
    name: 'PulseLoader',
    props:['quote', 'author', 'profession', 'img', 'loading','backgroundWhite', 'logo'],
    data(){
        return{
            msg : [
                {
                    quote: "Right now we are pulling the freshest data from the data sources.",
                },
                {
                    quote: "Now our algorithms are putting together the data based on your chosen parameters.",
                },
                {
                    quote: "We're almost done.",
                }
            ],
            i : 0
        }
    },
    mounted: function() {
        setInterval(() => {
            if (this.i !== 2) {
                this.i++            
            }                            
        },5000)
    },

}
</script>

<style lang="scss" scoped>
.pulse_loader{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 170px);
    position: absolute;
    top: 0;
    left: 0;
    background: #eee;
    z-index: 4;
    .loader_anim{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        span{
            width: 18px;
            height: 18px;
            margin: 5px;
            border-radius: 50%;
            background: #1053c7;
            animation: beat 1s linear infinite;
            &:nth-child(1) {
                animation-delay: 0s;
            }
            &:nth-child(2) {
                animation-delay: 0.2s;
            }
            &:nth-child(3) {
                animation-delay: 0.4s;
            }
            &:nth-child(4) {
                animation-delay: 0.6s;
            }
            &:nth-child(5) {
                animation-delay: 0.8s;
            }
        }
        @keyframes beat {
            0%, 100% {
                opacity: 1;
            }
            50% {
                opacity: 0.5;
            }
        }
    }
    .loader_text{
        font-size: 28px;
        line-height: 34px;
        color: #333;
        text-align: center;
        padding-top: 23rem;
        z-index: 9;
    }
    .p-fixed {
        position:fixed;
    }
    .author{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        span{
            padding-right: 15px;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;
            }
        }
        h4{
            font-size: 14px;
            line-height: 16px;
            text-transform: uppercase;
            font-weight: 600;
            color: #3b7ef1;
            margin: 0 0 5px;
        }
        h6{
            font-size: 12px;
            line-height: 15px;
            text-transform: capitalize;
            font-weight: 500;
            color: #666;
            margin: 0;
        }
    }
    &.sub_pulse{
        height: 60px;

    }
    &.hide{
        display: none;
    }
}
.img-loader-gif-white{
    max-height: 300px!important;
}
</style>